// Mock data for Myriad View Limited - Canada (frontend-only demo)

export const company = {
  name: "Myriad View Limited",
  branch: "Canada",
  legal: "Myriad View Limited (Canada)",
  tagline: "Managed Security. Real Confidence.",
  email: "info@myriadview.ca",
  phone: "+1 782 882 0899",
  phoneHref: "+17828820899",
  hours: "Mon – Fri: 08:00 AM – 05:00 PM AT",
  address: "256 Alabaster Way, Halifax, NS B3P 0G1, Canada",
  businessNumber: "751148578NS0001",
  social: { facebook: "#", twitter: "#", linkedin: "#", instagram: "#" },
};

export const images = {
  socRoom: "https://images.pexels.com/photos/19317897/pexels-photo-19317897.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  network: "https://images.unsplash.com/photo-1644325349124-d1756b79dd42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxuZXR3b3JrJTIwZGF0YXxlbnwwfHx8fDE3OTAwMTc1MjJ8MA&ixlib=rb-4.1.0&q=85",
  circuit: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5fGVufDB8fHx8MTc5MDAxNzUyMnww&ixlib=rb-4.1.0&q=85",
  analysts: "https://images.pexels.com/photos/5380655/pexels-photo-5380655.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  dataCenter: "https://images.pexels.com/photos/4508751/pexels-photo-4508751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  forensics: "https://images.unsplash.com/photo-1585079374502-415f8516dcc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwZm9yZW5zaWNzfGVufDB8fHx8MTc5MDAxNzU1MXww&ixlib=rb-4.1.0&q=85",
  servers: "https://images.unsplash.com/photo-1506399309177-3b43e99fead2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxzZXJ2ZXIlMjBkYXRhJTIwY2VudGVyfGVufDB8fHx8MTc5MDAxNzU1MXww&ixlib=rb-4.1.0&q=85",
  serverRack: "https://images.unsplash.com/photo-1762163516269-3c143e04175c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxzZXJ2ZXIlMjBkYXRhJTIwY2VudGVyfGVufDB8fHx8MTc5MDAxNzU1MXww&ixlib=rb-4.1.0&q=85",
  businessTeam: "https://images.unsplash.com/photo-1568992687947-868a62a9f521?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzkwMDE3NTUxfDA&ixlib=rb-4.1.0&q=85",
  training: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjB0cmFpbmluZ3xlbnwwfHx8fDE3OTAwMTc1NTh8MA&ixlib=rb-4.1.0&q=85",
  itPros: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxJVCUyMHByb2Zlc3Npb25hbHN8ZW58MHx8fHwxNzkwMDE3NTU4fDA&ixlib=rb-4.1.0&q=85",
};

export const stats = [
  { value: "24/7", label: "SOC Monitoring" },
  { value: "250+", label: "Threats Neutralized Monthly" },
  { value: "<15m", label: "Avg. Incident Response" },
  { value: "99.9%", label: "Service Uptime" },
];

export const services = [
  { id: "soc", icon: "ShieldCheck", title: "24/7 SOC as a Service", short: "Round-the-clock monitoring, detection and response from our Halifax-based Security Operations Center.", tag: "MSSP" },
  { id: "mssp", icon: "Server", title: "Managed Security (MSSP)", short: "Fully managed firewalls, endpoints, SIEM and cloud security so your team can focus on the business.", tag: "MSSP" },
  { id: "appsec", icon: "Code2", title: "Application Security Engineering", short: "Secure-by-design software: threat modeling, secure SDLC, SAST/DAST, code review and API/cloud-native security.", tag: "Core" },
  { id: "aigov", icon: "BrainCircuit", title: "AI/LLM Governance & Security", short: "Secure adoption of AI and large language models — governance frameworks, prompt-injection defense, model risk and data privacy.", tag: "Core" },
  { id: "compliance", icon: "ClipboardCheck", title: "Compliance Implementation", short: "End-to-end delivery of SOC 2, ISO 27001 and PIPEDA programs — gap analysis, control build-out, evidence automation and audit readiness.", tag: "Advisory" },
  { id: "risk", icon: "Gauge", title: "Risk & Compliance", short: "PIPEDA, SOC 2 and ISO 27001 readiness assessments tailored for Canadian organizations.", tag: "Advisory" },
  { id: "network", icon: "Network", title: "Network Security", short: "Zero-trust architecture, segmentation and next-gen firewall management across your estate.", tag: "Managed" },
  { id: "incident", icon: "Siren", title: "Incident Response", short: "Rapid on-site and remote response, containment and recovery with certified DFIR specialists.", tag: "Response" },
  { id: "forensics", icon: "Search", title: "Digital Forensics", short: "Court-admissible forensic examination of disks, mobile devices, cloud and email systems.", tag: "Forensics" },
  { id: "pentest", icon: "Bug", title: "Penetration Testing", short: "External, internal and web-app testing using recognized methodologies and expert consultants.", tag: "Offensive" },
  { id: "data", icon: "DatabaseBackup", title: "Backup & Data Recovery", short: "Resilient backup strategy plus recovery from logical or physical damage across all RAID levels.", tag: "Resilience" },
  { id: "email", icon: "Mail", title: "Email & Phishing Defense", short: "Advanced email filtering, DMARC enforcement and human-layer phishing simulation training.", tag: "Managed" },
];

export const capabilities = [
  { icon: "Code2", title: "Application Security Engineering", text: "Building security into every stage of the software lifecycle — threat modeling, secure SDLC, SAST/DAST automation, code and design reviews, plus API and cloud-native hardening.", image: "itPros" },
  { icon: "BrainCircuit", title: "AI/LLM Governance & Security", text: "Helping organizations adopt AI responsibly — governance and acceptable-use policy, model risk assessment, defense against prompt injection and data leakage, and alignment with emerging AI regulations and privacy law.", image: "circuit" },
  { icon: "Radar", title: "Forensic Incident Response", text: "Rapid covert or overt on-site response and lab-based forensic imaging of PCs, servers, networks and removable media using industry-standard methodologies.", image: "analysts" },
  { icon: "FileSearch", title: "Digital Forensic Investigations", text: "Examination of a wide range of digital media — hard disks, mobile phones, cloud storage, SANs/NAS and email systems — with defensible chain of custody.", image: "forensics" },
  { icon: "ShieldAlert", title: "Security Evaluations", text: "External and internal penetration testing, vulnerability assessment, firewall and IDS analysis, VPN and security architecture reviews.", image: "circuit" },
  { icon: "DatabaseBackup", title: "Data Recovery Services", text: "Recovery from logical or physical damage across all digital media types and every RAID configuration, with strict confidentiality.", image: "servers" },
];

export const socFeatures = [
  "Real-time threat detection with managed SIEM & XDR",
  "Certified analysts monitoring your estate 24/7/365",
  "Threat hunting and behavioural analytics",
  "Guided containment, remediation and reporting",
  "Canadian data residency and PIPEDA alignment",
];

export const partners = [
  "Threat Detection", "Digital Investigations", "Malware Analysis", "Vulnerability Management",
  "Application Security", "Data Protection", "File Integrity Monitoring", "Endpoint Protection",
];

export const trainings = [
  { title: "Certified Ethical Hacking", level: "Advanced", duration: "5 days", desc: "Hands-on offensive security techniques mapped to real attacker tradecraft." },
  { title: "Computer Hacking Forensic Investigation", level: "Advanced", duration: "5 days", desc: "Evidence acquisition, analysis and reporting for legal admissibility." },
  { title: "Malware Forensics", level: "Advanced", duration: "3 days", desc: "Static and dynamic analysis of modern malware and ransomware." },
  { title: "Penetration Testing Methodology", level: "Intermediate", duration: "4 days", desc: "Structured testing guide from scoping through remediation." },
  { title: "Building a Forensic First Response", level: "Intermediate", duration: "2 days", desc: "Preserve evidence and avoid contamination during the critical first hours." },
  { title: "Log Management & Incident Response", level: "Intermediate", duration: "3 days", desc: "Turn telemetry into actionable detection and response playbooks." },
  { title: "Information Security Awareness", level: "Foundation", duration: "1 day", desc: "Empower every employee to become a human firewall." },
  { title: "Network Fraud Analysis", level: "Intermediate", duration: "2 days", desc: "Detect, trace and mitigate fraud across network traffic." },
  { title: "ITIL & Service Management", level: "Foundation", duration: "3 days", desc: "Align IT service delivery with proven best-practice frameworks." },
];

export const team = [
  { name: "Adetunji Adeoje", role: "General Manager", bio: "Leads Myriad View's Canadian operations, bringing deep expertise in digital forensics, application security and cyber defense across global markets.", linkedin: "https://www.linkedin.com/in/adetunji-adeoje-5241094b/" },
  { name: "Sarah Whitfield", role: "Head of SOC Operations", bio: "Runs our Halifax SOC, specializing in detection engineering and threat hunting.", linkedin: "#" },
  { name: "Marcus Chen", role: "Lead DFIR Consultant", bio: "Certified incident responder with deep experience in ransomware containment.", linkedin: "#" },
  { name: "Priya Nair", role: "Governance & Compliance Lead", bio: "Guides clients through SOC 2, ISO 27001 and PIPEDA compliance journeys.", linkedin: "#" },
];

export const testimonials = [
  { quote: "Myriad View's SOC caught an intrusion attempt within minutes and walked us through containment. Genuine peace of mind.", name: "Operations Director", org: "Atlantic Logistics Co." },
  { quote: "Their forensic team delivered court-ready evidence under a tight deadline. Meticulous and professional throughout.", name: "General Counsel", org: "Maritime Legal Group" },
  { quote: "Moving to their managed security service cut our alert noise dramatically and freed our IT team to build.", name: "CTO", org: "HRM FinTech Startup" },
];

export const industries = [
  "Financial Services", "Healthcare", "Government & Public Sector",
  "Legal", "Manufacturing", "Education", "Retail & eCommerce", "Energy & Utilities",
];

export const complianceSteps = [
  { title: "Gap Analysis", text: "We assess your current posture against the target framework and map exactly where you stand today." },
  { title: "Control Build-out", text: "We design and implement the policies, technical controls and processes needed to close every gap." },
  { title: "Evidence Automation", text: "We wire up continuous evidence collection so audits become a formality, not a scramble." },
  { title: "Audit Readiness", text: "We run a readiness review and support you through the formal audit to certification." },
];

export const complianceFrameworks = [
  "SOC 2 Type II", "ISO/IEC 27001", "PIPEDA", "NIST CSF", "PCI DSS", "CIS Controls",
];

export const serviceDetails = [
  {
    icon: "Webhook",
    title: "API Security",
    intro: "Full-lifecycle protection for the APIs that power your business.",
    items: [
      "Discover all your APIs",
      "Prevent sensitive data exposure",
      "Stop API attacks",
      "Prevent ATO & data exfiltration",
      "\u201cShift Left\u201d proactive API security",
      "Accelerate incident response",
      "Provide remediation insights",
      "Simplify compliance",
    ],
  },
  {
    icon: "ClipboardCheck",
    title: "GRC",
    intro: "Governance, risk and compliance \u2014 helping you stay compliant with:",
    items: [
      "PIPEDA",
      "ISO 27001 & 27002",
      "SOC 2",
      "NIST 800-53",
      "GDPR",
      "HIPAA",
      "PCI DSS",
      "NCA, SAMA & ARAMCO CCC",
      "CST Framework, NDPR & UAE IA",
    ],
  },
  {
    icon: "Boxes",
    title: "Consultancy",
    intro: "Expert advisory across the full security program.",
    items: [
      "Audits, strategy & training",
      "Risk assessments",
      "GDPR and ISO compliance",
      "Penetration testing",
      "Identity & access management",
      "Infrastructure security review",
      "Application security review",
      "Source code review",
      "Reverse engineering",
    ],
  },
];

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Training", to: "/training" },
  { label: "Insights", to: "/insights" },
  { label: "Gallery", to: "/gallery" },
  { label: "Team", to: "/team" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const gallery = [
  { key: "socRoom", title: "Security Operations Center", category: "SOC" },
  { key: "analysts", title: "Threat Analysts at Work", category: "SOC" },
  { key: "dataCenter", title: "Managed Data Center", category: "Infrastructure" },
  { key: "serverRack", title: "Secure Server Estate", category: "Infrastructure" },
  { key: "forensics", title: "Digital Forensics Lab", category: "Forensics" },
  { key: "servers", title: "Backup & Recovery Suite", category: "Infrastructure" },
  { key: "circuit", title: "Application & Cloud Security", category: "AppSec" },
  { key: "network", title: "Network Threat Mapping", category: "Network" },
  { key: "training", title: "Hands-on Training Session", category: "Training" },
  { key: "itPros", title: "Engineering Team", category: "Team" },
  { key: "businessTeam", title: "Client Advisory Workshop", category: "Team" },
];

export const articles = [
  {
    slug: "soc-vs-mssp-canada",
    title: "SOC vs. MSSP: What Canadian businesses actually need in 2025",
    excerpt: "Building an in-house Security Operations Center is expensive. Here is how a managed service closes the gap \u2014 without the overhead.",
    category: "Managed Security",
    date: "June 18, 2025",
    readTime: "6 min read",
    author: "Sarah Whitfield",
    image: "socRoom",
    body: [
      "Every organization now depends on digital systems, and with that dependence comes exposure. The question is no longer whether you need continuous security monitoring, but how to deliver it sustainably.",
      "A Security Operations Center (SOC) gives you eyes on your environment every hour of every day. Standing one up in-house, however, means hiring scarce analysts, licensing a SIEM, and running a 24/7 rota \u2014 a significant investment before a single alert is triaged.",
      "A Managed Security Service Provider (MSSP) delivers the same outcome as a service. You gain certified analysts, mature detection content and tested response playbooks from day one, at a predictable monthly cost. For most Canadian mid-market organizations, this is the fastest path to meaningful protection.",
      "The right partner also keeps your data in Canada and aligns monitoring with PIPEDA and your sector's obligations \u2014 something worth confirming before you sign.",
    ],
  },
  {
    slug: "securing-llm-applications",
    title: "Securing LLM applications: a practical governance checklist",
    excerpt: "From prompt injection to data leakage, here are the controls every team should put in place before shipping AI features.",
    category: "AI/LLM Security",
    date: "June 2, 2025",
    readTime: "8 min read",
    author: "Marcus Chen",
    image: "circuit",
    body: [
      "Large language models unlock real productivity, but they also introduce a new and unfamiliar attack surface. Treating an AI feature like any other untrusted input is the first step toward using it safely.",
      "Start with governance: define acceptable use, document which data may be sent to a model, and record who owns the risk. Clear policy prevents well-meaning teams from quietly sending sensitive records to third-party services.",
      "On the technical side, assume prompt injection will happen. Validate and constrain model inputs and outputs, keep the model away from privileged actions it does not need, and log interactions so you can investigate later.",
      "Finally, watch for data leakage. Mask sensitive fields, prefer retrieval patterns that keep secrets out of prompts, and review vendor retention terms. Responsible AI adoption is mostly disciplined engineering.",
    ],
  },
  {
    slug: "incident-response-first-hour",
    title: "The first hour after a breach: what to do and what to avoid",
    excerpt: "The actions your team takes in the first sixty minutes often decide how costly an incident becomes.",
    category: "Incident Response",
    date: "May 21, 2025",
    readTime: "5 min read",
    author: "Adetunji Adeoje",
    image: "analysts",
    body: [
      "When an incident is discovered, the instinct to act fast is natural \u2014 but uncoordinated action frequently destroys the very evidence needed to understand what happened.",
      "Resist the urge to wipe and rebuild immediately. Preserve volatile data, isolate affected systems rather than powering them off where possible, and start a simple timeline of what was seen and when.",
      "Communicate through a pre-agreed channel and bring in your response partner early. A calm, documented first hour gives forensic specialists a defensible starting point and can dramatically reduce downtime.",
      "Most importantly, prepare before you need to. A short tabletop exercise today is worth far more than a perfect plan written during a crisis.",
    ],
  },
  {
    slug: "compliance-without-the-pain",
    title: "SOC 2 and ISO 27001 without the pain: an implementation roadmap",
    excerpt: "Compliance should be a byproduct of good security, not a paperwork marathon. Here is how to get there.",
    category: "Compliance",
    date: "May 7, 2025",
    readTime: "7 min read",
    author: "Priya Nair",
    image: "itPros",
    body: [
      "Many teams approach certification as a documentation exercise bolted on at the end. Done that way, it is painful, expensive and quickly out of date.",
      "A better approach treats the control framework as a blueprint for the security program you want anyway. Map each requirement to a practical control, assign an owner, and automate the evidence collection wherever you can.",
      "Scope tightly. Certifying your entire estate at once rarely helps; a focused scope that covers your core product gets you an attestation faster and builds momentum.",
      "With the right roadmap, SOC 2 or ISO 27001 becomes the natural result of running security well \u2014 and the audit becomes a formality rather than a fire drill.",
    ],
  },
];
